module.exports = __webpack_public_path__ + "media/images/icons/twitter_blue-d2605f49ca6a2c42e64c7d88b157f92b.svg";